import { NavLink, Outlet } from "react-router-dom";
import ApplicationLayoutBodyNavigation from "@rio-cloud/rio-uikit/ApplicationLayoutBodyNavigation";
import SubNavigation from "@rio-cloud/rio-uikit/SubNavigation";
import BackofficeLayout from "../BackofficeLayout";

const SupportPage = () => {
  const submenu = (
    <ApplicationLayoutBodyNavigation>
      <SubNavigation
        navItems={[
          {
            key: "matriz",
            route: (
              <NavLink to="/backoffice/support/matriz">
                RACI
              </NavLink>
            ),
          },
          {
            key: "subjects",
            route: (
              <NavLink to="/backoffice/support/subjects">
                Assuntos
              </NavLink>
            ),
          },
          {
            key: "subtopics",
            route: (
              <NavLink to="/backoffice/support/subtopics">
                Tema
              </NavLink>
            ),
          },
        ]}
      />
    </ApplicationLayoutBodyNavigation>
  );

  return (
    <BackofficeLayout submenu={submenu}>
      <Outlet />
    </BackofficeLayout>
  );
};

export default SupportPage;

